module.exports = __webpack_public_path__ + "static/media/2SGD.45bfe6d3.png";